var React = require('react');

function Download (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"download"),React.createElement("path",{"d":"M276.128 0h-276.216v512h396.43v-391.787zM43.989 468.099v-424.228h201.227v107.372h107.372v316.856z","key":1}),React.createElement("path",{"d":"M220.121 258.615v-87.126h-43.871v87.126l-25.683-25.683-31.031 31.031 78.634 78.633 78.663-78.634-31.030-31.030-25.683 25.682z","key":2}),React.createElement("path",{"d":"M135.053 367.486h126.267v43.901h-126.267v-43.901z","key":3})]);
}

Download.defaultProps = {"version":"1.1","width":"397","height":"512","viewBox":"0 0 397 512"};

module.exports = Download;

Download.default = Download;
